/**
 * LC Label Customizer - Presets par produit
 * Mis à jour par LC Editor — 2026-09-29T15:58:03.047Z
 */
window.LC_PRESETS = {
  "default": {
    "id": "default",
    "name": "Ensemble d'étiquettes",
    "mask": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/_masks/Garderie/kit-mask.png",
    "boxes": [
      {
        "type": "free",
        "x": 27,
        "y": 32,
        "scale": 1,
        "leftMargin": 12,
        "rightMargin": 12,
        "topMargin": 14,
        "bottomMargin": 260,
        "boxHeight": 131
      },
      {
        "type": "free",
        "x": 56,
        "y": 345,
        "scale": 0.4,
        "leftMargin": 47,
        "rightMargin": 300,
        "topMargin": 338,
        "bottomMargin": 63,
        "boxHeight": 149,
        "boxWidth": 265
      },
      {
        "type": "circle",
        "x": 354,
        "y": 325,
        "scale": 0.5,
        "circleCenterX": 353,
        "circleCenterY": 387,
        "circleRadius": 98,
        "textAlign": "center",
        "pivotAnchor": "top",
        "boxHeight": 145
      }
    ],
    "textFitMode": "perLine",
    "categories": [
      {
        "id": "divers",
        "name": "Divers",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/default/divers/",
        "models": [
          {
            "file": "kit-sushi-JUIN07-2024.jpg",
            "colors": [
              "#FFC0CB",
              "#FFD700"
            ]
          },
          {
            "file": "kit_agrumes_2024.jpg",
            "colors": [
              "#FFA500",
              "#FFFF00"
            ]
          },
          {
            "file": "kit_ananas_blue_2024.jpg",
            "colors": [
              "#0000FF",
              "#00FFFF"
            ]
          },
          {
            "file": "kit_ananas_mauve_2024.jpg",
            "colors": [
              "#800080",
              "#FFC0CB"
            ]
          },
          {
            "file": "kit_arc-en-ciel_2024.jpg",
            "colors": [
              "#FF0000",
              "#FFA500",
              "#FFFF00",
              "#008000",
              "#0000FF"
            ]
          },
          {
            "file": "kit_Astronaut_2024.jpg",
            "colors": [
              "#000000",
              "#FFFFFF"
            ]
          },
          {
            "file": "kit_beignet_2024.jpg",
            "colors": [
              "#D2691E",
              "#FFDAB9"
            ]
          },
          {
            "file": "kit_biscuit_2024.jpg",
            "colors": [
              "#F4A460",
              "#DEB887"
            ]
          },
          {
            "file": "kit_Boho_2024.jpg",
            "colors": [
              "#A52A2A",
              "#D2B48C"
            ]
          },
          {
            "file": "kit_bucheron_2024.jpg",
            "colors": [
              "#8B0000",
              "#000000"
            ]
          },
          {
            "file": "kit_cactus bleu_2024.jpg",
            "colors": [
              "#008080",
              "#0000FF"
            ]
          },
          {
            "file": "kit_cactus jaune_2024.jpg",
            "colors": [
              "#FFD700",
              "#FFA500"
            ]
          },
          {
            "file": "kit_campeur_2024.jpg",
            "colors": [
              "#556B2F",
              "#8B4513"
            ]
          },
          {
            "file": "kit_camping_2024.jpg",
            "colors": [
              "#32CD32",
              "#8B4513"
            ]
          },
          {
            "file": "kit_carnaval_2024.jpg",
            "colors": [
              "#FF4500",
              "#1E90FF"
            ]
          },
          {
            "file": "kit_champignon1_2024.jpg",
            "colors": [
              "#A0522D",
              "#FF6347"
            ]
          },
          {
            "file": "kit_champignon2_2024.jpg",
            "colors": [
              "#A0522D",
              "#8B4513"
            ]
          },
          {
            "file": "kit_coeur_2024.jpg",
            "colors": [
              "#FF0000",
              "#FFC0CB"
            ]
          },
          {
            "file": "kit_douceur_2024.jpg",
            "colors": [
              "#FFB6C1",
              "#FFFFE0"
            ]
          },
          {
            "file": "kit_Douce_melodie_2024.jpg",
            "colors": [
              "#7B68EE",
              "#87CEFA"
            ]
          },
          {
            "file": "kit_ferme_2024.jpg",
            "colors": [
              "#8B4513",
              "#32CD32"
            ]
          },
          {
            "file": "kit_feuillus 2_2024.jpg",
            "colors": [
              "#228B22",
              "#556B2F"
            ]
          },
          {
            "file": "kit_finesse_2024.jpg",
            "colors": [
              "#DDA0DD",
              "#FFDAB9"
            ]
          },
          {
            "file": "kit_fleur_2024.jpg",
            "colors": [
              "#FF69B4",
              "#87CEEB"
            ]
          },
          {
            "file": "kit_fraises_2024.jpg",
            "colors": [
              "#FF0000",
              "#32CD32"
            ]
          },
          {
            "file": "kit_gamer rouge_2024.jpg",
            "colors": [
              "#FF0000",
              "#000000"
            ]
          },
          {
            "file": "kit_gamer vert_2024.jpg",
            "colors": [
              "#008000",
              "#000000"
            ]
          },
          {
            "file": "kit_glacee_2024.jpg",
            "colors": [
              "#00FFFF",
              "#E0FFFF"
            ]
          },
          {
            "file": "kit_insecte_2024.jpg",
            "colors": [
              "#556B2F",
              "#8B0000"
            ]
          },
          {
            "file": "kit_machienrie_2024.jpg",
            "colors": [
              "#B0C4DE",
              "#708090"
            ]
          },
          {
            "file": "kit_magie_2024.jpg",
            "colors": [
              "#4B0082",
              "#8A2BE2"
            ]
          },
          {
            "file": "kit_Melon_2024.jpg",
            "colors": [
              "#FF6347",
              "#FFD700"
            ]
          },
          {
            "file": "kit_mer_2024.jpg",
            "colors": [
              "#4682B4",
              "#00BFFF"
            ]
          },
          {
            "file": "kit_motocross_2024.jpg",
            "colors": [
              "#FF4500",
              "#FFD700"
            ]
          },
          {
            "file": "kit_moustache_2024.jpg",
            "colors": [
              "#000000",
              "#A9A9A9"
            ]
          },
          {
            "file": "kit_NEW_cupcake_2024.jpg",
            "colors": [
              "#FF69B4",
              "#87CEEB"
            ]
          },
          {
            "file": "kit_petite_foret_2024.jpg",
            "colors": [
              "#228B22",
              "#6B8E23"
            ]
          },
          {
            "file": "kit_princesse_2024.jpg",
            "colors": [
              "#FF69B4",
              "#DDA0DD"
            ]
          },
          {
            "file": "kit_ptitmonstre_2024.jpg",
            "colors": [
              "#8B0000",
              "#00008B"
            ]
          },
          {
            "file": "kit_Souslocean_2024.jpg",
            "colors": [
              "#1E90FF",
              "#00BFFF"
            ]
          },
          {
            "file": "kit_superhero_2024.jpg",
            "colors": [
              "#0000FF",
              "#FFD700"
            ]
          },
          {
            "file": "kit_Tracteur_2024.jpg",
            "colors": [
              "#228B22",
              "#FF4500"
            ]
          },
          {
            "file": "kit_tropique_2024.jpg",
            "colors": [
              "#FFD700",
              "#FF6347"
            ]
          }
        ]
      },
      {
        "id": "animaux",
        "name": "Animaux",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/default/animaux/",
        "models": [
          {
            "file": "kit_cameleon_2024-new.jpg",
            "colors": [
              "#008000",
              "#FFD700"
            ]
          },
          {
            "file": "kit_chat_2024.jpg",
            "colors": [
              "#D3D3D3",
              "#000000"
            ]
          },
          {
            "file": "kit_cheval_2024.jpg",
            "colors": [
              "#A52A2A",
              "#8B4513"
            ]
          },
          {
            "file": "kit_chien_2024.jpg",
            "colors": [
              "#8B4513",
              "#D2691E"
            ]
          },
          {
            "file": "kit_cochon_2024.jpg",
            "colors": [
              "#FFC0CB",
              "#FF69B4"
            ]
          },
          {
            "file": "kit_Dino Rose_2024.jpg",
            "colors": [
              "#FF69B4",
              "#FFD700"
            ]
          },
          {
            "file": "kit_dino vert_2024.jpg",
            "colors": [
              "#008000",
              "#006400"
            ]
          },
          {
            "file": "kit_foret_2024.jpg",
            "colors": [
              "#228B22",
              "#6B8E23"
            ]
          },
          {
            "file": "kit_herisson_2024.jpg",
            "colors": [
              "#A0522D",
              "#DEB887"
            ]
          },
          {
            "file": "kit_Koala_2024.jpg",
            "colors": [
              "#696969",
              "#A9A9A9"
            ]
          },
          {
            "file": "kit_Lapin-doux_2024.jpg",
            "colors": [
              "#FFDAB9",
              "#F5DEB3"
            ]
          },
          {
            "file": "kit_lapin_2024.jpg",
            "colors": [
              "#FFE4B5",
              "#8B4513"
            ]
          },
          {
            "file": "kit_licorne_2024.jpg",
            "colors": [
              "#FF69B4",
              "#87CEEB"
            ]
          },
          {
            "file": "kit_minou_2024.jpg",
            "colors": [
              "#FFD700",
              "#000000"
            ]
          },
          {
            "file": "kit_NEW_flamant_2024.jpg",
            "colors": [
              "#FF69B4",
              "#FF4500"
            ]
          },
          {
            "file": "kit_panda_2024.jpg",
            "colors": [
              "#000000",
              "#FFFFFF"
            ]
          },
          {
            "file": "kit_paresseux_2024.jpg",
            "colors": [
              "#8B4513",
              "#A0522D"
            ]
          },
          {
            "file": "kit_pitou_2024.jpg",
            "colors": [
              "#D2691E",
              "#FFD700"
            ]
          },
          {
            "file": "kit_Pug_2024.jpg",
            "colors": [
              "#A52A2A",
              "#FFDAB9"
            ]
          },
          {
            "file": "kit_renard bleu_2024.jpg",
            "colors": [
              "#0000FF",
              "#1E90FF"
            ]
          },
          {
            "file": "kit_renard rose_2024.jpg",
            "colors": [
              "#FFC0CB",
              "#FF69B4"
            ]
          },
          {
            "file": "kit_renard_2024.jpg",
            "colors": [
              "#FFA500",
              "#FF4500"
            ]
          },
          {
            "file": "kit_savane_2024.jpg",
            "colors": [
              "#FFD700",
              "#F4A460"
            ]
          },
          {
            "file": "kit_singe_2024.jpg",
            "colors": [
              "#8B4513",
              "#D2691E"
            ]
          },
          {
            "file": "kit_sirene_2024.jpg",
            "colors": [
              "#87CEEB",
              "#00BFFF"
            ]
          },
          {
            "file": "kit_tortue_2024.jpg",
            "colors": [
              "#008000",
              "#32CD32"
            ]
          }
        ]
      },
      {
        "id": "sport",
        "name": "Sport",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/default/sport/",
        "models": [
          {
            "file": "kit_Ballerine A_2024.jpg",
            "colors": [
              "#FF69B4",
              "#FFDAB9"
            ]
          },
          {
            "file": "kit_Ballerine B_2024.jpg",
            "colors": [
              "#FF1493",
              "#FFE4B5"
            ]
          },
          {
            "file": "kit_Baseball_2024.jpg",
            "colors": [
              "#0000FF",
              "#FFFFFF"
            ]
          },
          {
            "file": "kit_Hockey_2024.jpg",
            "colors": [
              "#000000",
              "#FF0000"
            ]
          },
          {
            "file": "kit_Skateboard_2024.jpg",
            "colors": [
              "#32CD32",
              "#FFD700"
            ]
          },
          {
            "file": "kit_Soccer_2024.jpg",
            "colors": [
              "#008000",
              "#FFFFFF"
            ]
          },
          {
            "file": "kit_Surf_2024.jpg",
            "colors": [
              "#00CED1",
              "#1E90FF"
            ]
          },
          {
            "file": "kit_voiture rose_2024.jpg",
            "colors": [
              "#FFC0CB",
              "#000000"
            ]
          }
        ]
      },
      {
        "id": "uni",
        "name": "Uni",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/default/uni/",
        "models": [
          {
            "file": "kit-blanc.jpg",
            "colors": [
              "#000000",
              "#D3D3D3"
            ]
          },
          {
            "file": "kit-camoufle.jpg",
            "colors": [
              "#556B2F",
              "#8B4513"
            ]
          },
          {
            "file": "kit-cieldete.jpg",
            "colors": [
              "#87CEEB",
              "#1E90FF"
            ]
          },
          {
            "file": "kit-lagrappe.jpg",
            "colors": [
              "#800080",
              "#FFC0CB"
            ]
          },
          {
            "file": "kit-lavague-new.jpg",
            "colors": [
              "#4682B4",
              "#00BFFF"
            ]
          },
          {
            "file": "kit-leclatant.jpg",
            "colors": [
              "#FFD700",
              "#FFA500"
            ]
          },
          {
            "file": "kit-Lefeuillus.jpg",
            "colors": [
              "#228B22",
              "#6B8E23"
            ]
          },
          {
            "file": "kit-letoile.jpg",
            "colors": [
              "#00008B",
              "#FFFFFF"
            ]
          },
          {
            "file": "kit-locre.jpg",
            "colors": [
              "#DAA520",
              "#8B4513"
            ]
          },
          {
            "file": "kit-lorangier.jpg",
            "colors": [
              "#FF4500",
              "#FF6347"
            ]
          },
          {
            "file": "kit-rosee.jpg",
            "colors": [
              "#FFC0CB",
              "#FFF5EE"
            ]
          }
        ]
      }
    ]
  },
  "petite-etiquette": {
    "id": "petite-etiquette",
    "name": "Petite étiquette d'identification",
    "mask": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/_masks/petite-mask.png",
    "boxes": [
      {
        "type": "free",
        "x": 40,
        "y": 64,
        "scale": 1,
        "leftMargin": 40,
        "rightMargin": 40,
        "topMargin": 30,
        "bottomMargin": 40,
        "boxHeight": 150
      }
    ],
    "categories": [
      {
        "id": "divers",
        "name": "Divers",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/petite-etiquette/divers/",
        "models": [
          {
            "file": "petite-mauve-new2024.jpg"
          },
          {
            "file": "petite-rose-new2024.jpg"
          },
          {
            "file": "petite_Biscuit_2024.jpg"
          },
          {
            "file": "petite_Melon_2024.jpg",
            "colors": [
              "#FF6347",
              "#FFD700"
            ]
          },
          {
            "file": "petite_Tracteur_2024.jpg",
            "colors": [
              "#228B22",
              "#FF4500"
            ]
          },
          {
            "file": "petite_ananas_bleu_2024.jpg"
          },
          {
            "file": "petite_ananas_rose_2024.jpg"
          },
          {
            "file": "petite_arc-en-ciel_2024.jpg",
            "colors": [
              "#FF0000",
              "#FFA500",
              "#FFFF00",
              "#008000",
              "#0000FF"
            ]
          },
          {
            "file": "petite_cactus bleu_2024.jpg",
            "colors": [
              "#008080",
              "#0000FF"
            ]
          },
          {
            "file": "petite_cactus jaune_2024.jpg",
            "colors": [
              "#FFD700",
              "#FFA500"
            ]
          },
          {
            "file": "petite_coeur_2024.jpg",
            "colors": [
              "#FF0000",
              "#FFC0CB"
            ]
          },
          {
            "file": "petite_cupcake_2024.jpg",
            "colors": [
              "#FF69B4",
              "#87CEEB"
            ]
          },
          {
            "file": "petite_fleur_2024.jpg",
            "colors": [
              "#FF69B4",
              "#87CEEB"
            ]
          },
          {
            "file": "petite_gamer rouge_2024.jpg",
            "colors": [
              "#FF0000",
              "#000000"
            ]
          },
          {
            "file": "petite_gamer vert_2024.jpg",
            "colors": [
              "#008000",
              "#000000"
            ]
          },
          {
            "file": "petite_magie_2024.jpg",
            "colors": [
              "#4B0082",
              "#8A2BE2"
            ]
          },
          {
            "file": "petite_moustache_2024.jpg",
            "colors": [
              "#000000",
              "#A9A9A9"
            ]
          },
          {
            "file": "petite_superhero_2024.jpg",
            "colors": [
              "#0000FF",
              "#FFD700"
            ]
          }
        ]
      },
      {
        "id": "animaux",
        "name": "Animaux",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/petite-etiquette/animaux/",
        "models": [
          {
            "file": "petite_Dino Rose_2024.jpg",
            "colors": [
              "#FF69B4",
              "#FFD700"
            ]
          },
          {
            "file": "petite_Koala_2024.jpg",
            "colors": [
              "#696969",
              "#A9A9A9"
            ]
          },
          {
            "file": "petite_chat_2024.jpg",
            "colors": [
              "#D3D3D3",
              "#000000"
            ]
          },
          {
            "file": "petite_cheval_2024.jpg",
            "colors": [
              "#A52A2A",
              "#8B4513"
            ]
          },
          {
            "file": "petite_chien_2024.jpg",
            "colors": [
              "#8B4513",
              "#D2691E"
            ]
          },
          {
            "file": "petite_cochon_2024.jpg",
            "colors": [
              "#FFC0CB",
              "#FF69B4"
            ]
          },
          {
            "file": "petite_dino vert_2024.jpg",
            "colors": [
              "#008000",
              "#006400"
            ]
          },
          {
            "file": "petite_flamant_2024.jpg",
            "colors": [
              "#FF69B4",
              "#FF4500"
            ]
          },
          {
            "file": "petite_herisson_2024.jpg",
            "colors": [
              "#A0522D",
              "#DEB887"
            ]
          },
          {
            "file": "petite_hibou_2025.jpg"
          },
          {
            "file": "petite_lapin_2024.jpg",
            "colors": [
              "#FFE4B5",
              "#8B4513"
            ]
          },
          {
            "file": "petite_licorne_2024.jpg",
            "colors": [
              "#FF69B4",
              "#87CEEB"
            ]
          },
          {
            "file": "petite_panda_2024.jpg",
            "colors": [
              "#000000",
              "#FFFFFF"
            ]
          },
          {
            "file": "petite_renard bleu_2024.jpg",
            "colors": [
              "#0000FF",
              "#1E90FF"
            ]
          },
          {
            "file": "petite_renard rose_2024.jpg",
            "colors": [
              "#FFC0CB",
              "#FF69B4"
            ]
          },
          {
            "file": "petite_sirene_2024.jpg",
            "colors": [
              "#87CEEB",
              "#00BFFF"
            ]
          }
        ]
      },
      {
        "id": "sport",
        "name": "Sport",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/petite-etiquette/sport/",
        "models": [
          {
            "file": "petite-MULTISPORT-VISUEL2024.jpg"
          },
          {
            "file": "petite_Ballerine A_2024.jpg",
            "colors": [
              "#FF69B4",
              "#FFDAB9"
            ]
          },
          {
            "file": "petite_Ballerine B_2024.jpg",
            "colors": [
              "#FF1493",
              "#FFE4B5"
            ]
          },
          {
            "file": "petite_Baseball_2024.jpg",
            "colors": [
              "#0000FF",
              "#FFFFFF"
            ]
          },
          {
            "file": "petite_Hockey_2024.jpg",
            "colors": [
              "#000000",
              "#FF0000"
            ]
          },
          {
            "file": "petite_Skateboard_2024.jpg",
            "colors": [
              "#32CD32",
              "#FFD700"
            ]
          },
          {
            "file": "petite_Soccer_2024.jpg",
            "colors": [
              "#008000",
              "#FFFFFF"
            ]
          },
          {
            "file": "petite_Surf_2024.jpg",
            "colors": [
              "#00CED1",
              "#1E90FF"
            ]
          },
          {
            "file": "petite_multisport_2025.jpg"
          },
          {
            "file": "petite_voiture rose_2024.jpg",
            "colors": [
              "#FFC0CB",
              "#000000"
            ]
          }
        ]
      },
      {
        "id": "uni",
        "name": "Uni",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/petite-etiquette/uni/",
        "models": [
          {
            "file": "petite-aquarelle-camoufleArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-aquarelle-cieldeteArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-aquarelle-feuillusArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-aquarelle-lagrappeArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-aquarelle-lavagueArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-aquarelle-leclatantArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-aquarelle-letoileArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-aquarelle-locreArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-aquarelle-orangierArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-aquarelle-rosieArtboard 68@800x-80.jpg"
          },
          {
            "file": "petite-uni-blancArtboard 68@800x-80.jpg"
          }
        ]
      }
    ]
  },
  "moyenne": {
    "id": "moyenne",
    "name": "Moyenne étiquettes",
    "mask": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/_masks/Moyenne-Mask-2024.png",
    "boxes": [
      {
        "type": "free",
        "x": 29,
        "y": 34,
        "scale": 1,
        "leftMargin": 15,
        "rightMargin": 15,
        "topMargin": 16,
        "bottomMargin": 20,
        "boxHeight": 92
      }
    ],
    "categories": [
      {
        "id": "divers",
        "name": "Divers",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/moyenne/divers/",
        "models": [
          {
            "file": "moyen-biscuit-2024.jpg"
          },
          {
            "file": "moyen_boucle_mauve2024.jpg"
          },
          {
            "file": "moyen_boucle_rose2024.jpg"
          },
          {
            "file": "moyenne_Melon_2024.jpg",
            "colors": [
              "#FF6347",
              "#FFD700"
            ]
          },
          {
            "file": "moyenne_Tracteur_2024.jpg",
            "colors": [
              "#228B22",
              "#FF4500"
            ]
          },
          {
            "file": "moyenne_ananas_blue_2024.jpg",
            "colors": [
              "#0000FF",
              "#00FFFF"
            ]
          },
          {
            "file": "moyenne_ananas_rose_2024.jpg"
          },
          {
            "file": "moyenne_arc-en-ciel_2024.jpg",
            "colors": [
              "#FF0000",
              "#FFA500",
              "#FFFF00",
              "#008000",
              "#0000FF"
            ]
          },
          {
            "file": "moyenne_cactus bleu_2024.jpg",
            "colors": [
              "#008080",
              "#0000FF"
            ]
          },
          {
            "file": "moyenne_cactus jaune_2024.jpg",
            "colors": [
              "#FFD700",
              "#FFA500"
            ]
          },
          {
            "file": "moyenne_coeur_2024.jpg",
            "colors": [
              "#FF0000",
              "#FFC0CB"
            ]
          },
          {
            "file": "moyenne_coeur_2025.jpg"
          },
          {
            "file": "moyenne_cupcake_2024.jpg",
            "colors": [
              "#FF69B4",
              "#87CEEB"
            ]
          },
          {
            "file": "moyenne_fleur_2024.jpg",
            "colors": [
              "#FF69B4",
              "#87CEEB"
            ]
          },
          {
            "file": "moyenne_gamer rouge_2024.jpg",
            "colors": [
              "#FF0000",
              "#000000"
            ]
          },
          {
            "file": "moyenne_gamer vert_2024.jpg",
            "colors": [
              "#008000",
              "#000000"
            ]
          },
          {
            "file": "moyenne_magie_2024.jpg",
            "colors": [
              "#4B0082",
              "#8A2BE2"
            ]
          },
          {
            "file": "moyenne_moustache_2024.jpg",
            "colors": [
              "#000000",
              "#A9A9A9"
            ]
          },
          {
            "file": "moyenne_superhero_2024.jpg",
            "colors": [
              "#0000FF",
              "#FFD700"
            ]
          }
        ]
      },
      {
        "id": "animaux",
        "name": "Animaux",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/moyenne/animaux/",
        "models": [
          {
            "file": "moyen_hibou_2025.jpg"
          },
          {
            "file": "moyenne-renard-rose-2025.jpg"
          },
          {
            "file": "moyenne_Dino Rose_2024.jpg",
            "colors": [
              "#FF69B4",
              "#FFD700"
            ]
          },
          {
            "file": "moyenne_Koala_2024.jpg",
            "colors": [
              "#696969",
              "#A9A9A9"
            ]
          },
          {
            "file": "moyenne_chat_2024.jpg",
            "colors": [
              "#D3D3D3",
              "#000000"
            ]
          },
          {
            "file": "moyenne_cheval_2024.jpg",
            "colors": [
              "#A52A2A",
              "#8B4513"
            ]
          },
          {
            "file": "moyenne_chien_2024.jpg",
            "colors": [
              "#8B4513",
              "#D2691E"
            ]
          },
          {
            "file": "moyenne_cochon_2024.jpg",
            "colors": [
              "#FFC0CB",
              "#FF69B4"
            ]
          },
          {
            "file": "moyenne_dino vert_2024.jpg",
            "colors": [
              "#008000",
              "#006400"
            ]
          },
          {
            "file": "moyenne_flamant_2024.jpg",
            "colors": [
              "#FF69B4",
              "#FF4500"
            ]
          },
          {
            "file": "moyenne_herisson_2024.jpg",
            "colors": [
              "#A0522D",
              "#DEB887"
            ]
          },
          {
            "file": "moyenne_lapin_2024.jpg",
            "colors": [
              "#FFE4B5",
              "#8B4513"
            ]
          },
          {
            "file": "moyenne_licorne_2024.jpg",
            "colors": [
              "#FF69B4",
              "#87CEEB"
            ]
          },
          {
            "file": "moyenne_panda_2024.jpg",
            "colors": [
              "#000000",
              "#FFFFFF"
            ]
          },
          {
            "file": "moyenne_renard bleu_2024.jpg",
            "colors": [
              "#0000FF",
              "#1E90FF"
            ]
          },
          {
            "file": "moyenne_renard rose_2024.jpg",
            "colors": [
              "#FFC0CB",
              "#FF69B4"
            ]
          },
          {
            "file": "moyenne_sirene_2024.jpg",
            "colors": [
              "#87CEEB",
              "#00BFFF"
            ]
          }
        ]
      },
      {
        "id": "aquarelle",
        "name": "Aquarelle",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/moyenne/aquarelle/",
        "models": [
          {
            "file": "moyen--POP-SICLE-2024.jpg"
          },
          {
            "file": "moyen-ARCENCIEL25-2024.jpg"
          },
          {
            "file": "moyen-BEIGNEEE-2024.jpg"
          },
          {
            "file": "moyen-CAMPING-2-2024.jpg"
          },
          {
            "file": "moyen-FERME-2-2024.jpg"
          },
          {
            "file": "moyen-HIBOU-2024.jpg"
          },
          {
            "file": "moyen-MER-2-2024.jpg"
          },
          {
            "file": "moyen-MINOU-2-2024.jpg"
          },
          {
            "file": "moyen-PEPINE.jpg"
          },
          {
            "file": "moyen-cowboy-2025.jpg"
          },
          {
            "file": "moyen-mer-2024.jpg"
          },
          {
            "file": "moyen-pug-2024.jpg"
          },
          {
            "file": "moyen-renard-2024.jpg"
          },
          {
            "file": "moyen-singe-2024.jpg"
          },
          {
            "file": "moyen-souslocean-2024.jpg"
          },
          {
            "file": "moyen-sushis-22024.jpg"
          },
          {
            "file": "moyen-tropique-2024.jpg"
          },
          {
            "file": "moyen_arcenciel-rose_2024.jpg"
          },
          {
            "file": "moyen_monstre_2024.jpg",
            "colors": [
              "#8B0000",
              "#00008B"
            ]
          },
          {
            "file": "moyen_pyjama-party-2024.jpg"
          },
          {
            "file": "moyenne_Boho_2024.jpg",
            "colors": [
              "#A52A2A",
              "#D2B48C"
            ]
          },
          {
            "file": "moyenne_Lapin-doux_2024.jpg",
            "colors": [
              "#FFDAB9",
              "#F5DEB3"
            ]
          },
          {
            "file": "moyenne_NEW_minou_2024.jpg",
            "colors": [
              "#FFD700",
              "#000000"
            ]
          },
          {
            "file": "moyenne_PRINCESSE-2_2024.jpg"
          },
          {
            "file": "moyenne_Souslocean_2024.jpg",
            "colors": [
              "#1E90FF",
              "#00BFFF"
            ]
          },
          {
            "file": "moyenne_Xtreme_2024.jpg"
          },
          {
            "file": "moyenne_agrumes_2024.jpg",
            "colors": [
              "#FFA500",
              "#FFFF00"
            ]
          },
          {
            "file": "moyenne_agrumes_2025.jpg"
          },
          {
            "file": "moyenne_astronaut_2024.jpg"
          },
          {
            "file": "moyenne_beignet_2024.jpg",
            "colors": [
              "#D2691E",
              "#FFDAB9"
            ]
          },
          {
            "file": "moyenne_bucheron_2024.jpg",
            "colors": [
              "#8B0000",
              "#000000"
            ]
          },
          {
            "file": "moyenne_cameleon_2024.jpg"
          },
          {
            "file": "moyenne_campeur_2024.jpg",
            "colors": [
              "#556B2F",
              "#8B4513"
            ]
          },
          {
            "file": "moyenne_camping_2024.jpg",
            "colors": [
              "#32CD32",
              "#8B4513"
            ]
          },
          {
            "file": "moyenne_carnaval_2024.jpg",
            "colors": [
              "#FF4500",
              "#1E90FF"
            ]
          },
          {
            "file": "moyenne_champignon10_2024.jpg"
          },
          {
            "file": "moyenne_champignon1_2024.jpg",
            "colors": [
              "#A0522D",
              "#FF6347"
            ]
          },
          {
            "file": "moyenne_champignon2_2024.jpg",
            "colors": [
              "#A0522D",
              "#8B4513"
            ]
          },
          {
            "file": "moyenne_douce-melodie_2024.jpg"
          },
          {
            "file": "moyenne_douceur_2024.jpg",
            "colors": [
              "#FFB6C1",
              "#FFFFE0"
            ]
          },
          {
            "file": "moyenne_ferme_2024.jpg",
            "colors": [
              "#8B4513",
              "#32CD32"
            ]
          },
          {
            "file": "moyenne_feuillus 2_2024.jpg",
            "colors": [
              "#228B22",
              "#556B2F"
            ]
          },
          {
            "file": "moyenne_finesse_2024.jpg",
            "colors": [
              "#DDA0DD",
              "#FFDAB9"
            ]
          },
          {
            "file": "moyenne_foret_2024.jpg",
            "colors": [
              "#228B22",
              "#6B8E23"
            ]
          },
          {
            "file": "moyenne_fraises_2024.jpg",
            "colors": [
              "#FF0000",
              "#32CD32"
            ]
          },
          {
            "file": "moyenne_glacee_2024.jpg",
            "colors": [
              "#00FFFF",
              "#E0FFFF"
            ]
          },
          {
            "file": "moyenne_insecte_2024.jpg",
            "colors": [
              "#556B2F",
              "#8B0000"
            ]
          },
          {
            "file": "moyenne_machienrie_2024.jpg",
            "colors": [
              "#B0C4DE",
              "#708090"
            ]
          },
          {
            "file": "moyenne_mer2_2024.jpg"
          },
          {
            "file": "moyenne_motocross_2024.jpg",
            "colors": [
              "#FF4500",
              "#FFD700"
            ]
          },
          {
            "file": "moyenne_paresseux_2024.jpg",
            "colors": [
              "#8B4513",
              "#A0522D"
            ]
          },
          {
            "file": "moyenne_petite-foret_2024.jpg",
            "colors": [
              "#228B22",
              "#6B8E23"
            ]
          },
          {
            "file": "moyenne_pitou_2024.jpg",
            "colors": [
              "#D2691E",
              "#FFD700"
            ]
          },
          {
            "file": "moyenne_poisson_2024.jpg"
          },
          {
            "file": "moyenne_princesse_2024.jpg",
            "colors": [
              "#FF69B4",
              "#DDA0DD"
            ]
          },
          {
            "file": "moyenne_pug_2024.jpg"
          },
          {
            "file": "moyenne_savane_2024.jpg",
            "colors": [
              "#FFD700",
              "#F4A460"
            ]
          },
          {
            "file": "moyenne_sushis_2024.jpg"
          },
          {
            "file": "moyenne_tortue_2024.jpg",
            "colors": [
              "#008000",
              "#32CD32"
            ]
          },
          {
            "file": "savane.jpg"
          }
        ]
      },
      {
        "id": "sport",
        "name": "Sport",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/moyenne/sport/",
        "models": [
          {
            "file": "moyen-multisport-montage2024.jpg"
          },
          {
            "file": "moyenne_Ballerine A_2024.jpg",
            "colors": [
              "#FF69B4",
              "#FFDAB9"
            ]
          },
          {
            "file": "moyenne_Ballerine B_2024.jpg",
            "colors": [
              "#FF1493",
              "#FFE4B5"
            ]
          },
          {
            "file": "moyenne_Baseball_2024.jpg",
            "colors": [
              "#0000FF",
              "#FFFFFF"
            ]
          },
          {
            "file": "moyenne_Hockey_2024.jpg",
            "colors": [
              "#000000",
              "#FF0000"
            ]
          },
          {
            "file": "moyenne_NEW_voiture rose_2024.jpg",
            "colors": [
              "#FFC0CB",
              "#000000"
            ]
          },
          {
            "file": "moyenne_Skateboard_2024.jpg",
            "colors": [
              "#32CD32",
              "#FFD700"
            ]
          },
          {
            "file": "moyenne_Soccer_2024.jpg",
            "colors": [
              "#008000",
              "#FFFFFF"
            ]
          },
          {
            "file": "moyenne_Surf_2024.jpg",
            "colors": [
              "#00CED1",
              "#1E90FF"
            ]
          },
          {
            "file": "moyenne_multisport_2025.jpg"
          }
        ]
      },
      {
        "id": "uni",
        "name": "Uni",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/moyenne/uni/",
        "models": [
          {
            "file": "moyenne_blanc_2024.jpg"
          },
          {
            "file": "moyenne_cieldete_2024.jpg"
          },
          {
            "file": "moyenne_lagrappe_2024.jpg"
          },
          {
            "file": "moyenne_lavague_2024.jpg"
          },
          {
            "file": "moyenne_lecamoufle_2024.jpg"
          },
          {
            "file": "moyenne_leclatant_2024.jpg"
          },
          {
            "file": "moyenne_lefeuillus_2024.jpg"
          },
          {
            "file": "moyenne_letoile_2024.jpg"
          },
          {
            "file": "moyenne_locre_2024.jpg"
          },
          {
            "file": "moyenne_loranger_2024.jpg"
          },
          {
            "file": "moyenne_rosee_2024.jpg"
          }
        ]
      }
    ]
  },
  "etiquettes-ronde": {
    "id": "etiquettes-ronde",
    "name": "Étiquette ronde",
    "mask": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/_masks/ronde-MASK.png",
    "boxes": [
      {
        "type": "circle",
        "x": 255,
        "y": 154,
        "scale": 1,
        "boxWidth": 397,
        "boxHeight": 168,
        "circleCenterX": 252,
        "circleCenterY": 251,
        "circleRadius": 227,
        "pivotAnchor": "top",
        "textAlign": "center"
      }
    ],
    "categories": [
      {
        "id": "animaux",
        "name": "Animaux",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/etiquettes-ronde/animaux/",
        "models": [
          {
            "file": "ronde_Dino Rose_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_Koala_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_NEW_flamant_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_chat_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_cheval_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_chien_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_cochon_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_dino vert_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_herisson_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_hibou1_2025.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_hibou_2025.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_lapin_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_licorne_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_panda_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_renard bleu_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_renard rose_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "ronde_sirene_2024.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          }
        ]
      }
    ]
  },
  "ensemble-garderie": {
    "id": "ensemble-garderie",
    "name": "Ensemble Garderie",
    "mask": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/_masks/Garderie/mask-kit-garderie.png",
    "boxes": [
      {
        "type": "free",
        "x": 52,
        "y": 93,
        "scale": 0.5,
        "boxWidth": 228,
        "boxHeight": 72,
        "leftMargin": 49,
        "rightMargin": 300,
        "topMargin": 84,
        "bottomMargin": 207
      },
      {
        "type": "circle",
        "x": 353,
        "y": 89,
        "scale": 0.55,
        "boxWidth": 296,
        "boxHeight": 168,
        "circleCenterX": 353,
        "circleCenterY": 134,
        "circleRadius": 96,
        "pivotAnchor": "top"
      },
      {
        "type": "free",
        "x": 77,
        "y": 295,
        "scale": 1,
        "textAlign": "left",
        "boxWidth": 275,
        "boxHeight": 168,
        "leftMargin": 66,
        "rightMargin": 67,
        "topMargin": 285,
        "bottomMargin": 17
      }
    ],
    "categories": [
      {
        "id": "divers",
        "name": "Divers",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/ensemble-garderie/divers/",
        "models": [
          {
            "file": "DOUCEUR.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-ARCENCIEL.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-ASTRONAUTE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-BOHO.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-BOUCLE-MAUVE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-BOUCLE-ROSE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-BUCHERON.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CACTUS-BLEU.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CACTUS-JAUNE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CAMPEUR.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CAMPING.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CARNAVAL.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-COEURS-2025.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-COEURS-2026.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-COEURS.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-COWBOY.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-FERME.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-FEUILLUS.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-FINESSE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-FLEURS.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-GAMER-ROUGE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-GAMER-VERT.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-JARDIN-DE-FLEURS.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MACHINERIE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MAGIE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MARGUERITE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MER.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MONSTERTRUCK-AJUSTE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MONSTERTRUCK.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MOUSTACHE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-PIVOINES.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-PRINCESSE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-PYJAMA-PARTY.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-ROSIE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SOURIRE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SUPERHERO.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-TRACTEUR.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-TROPIQUE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          }
        ]
      },
      {
        "id": "aliments",
        "name": "ALIMENTS",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/ensemble-garderie/aliments/",
        "models": [
          {
            "file": "GARDERIE-AGRUMES.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-ANANAS-BLEU.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-ANANAS-MAUVE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-BEIGNES.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-BISCUIT.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CHAMPIGNON.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CHAMPIGNONNE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CUPCAKE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-FRAISES.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-GLACE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MELON.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SUSHIS.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          }
        ]
      },
      {
        "id": "animaux",
        "name": "ANIMAUX",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/ensemble-garderie/animaux/",
        "models": [
          {
            "file": "GARDERIE-1-HIBOU.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CAMELEON.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CHAT-2026.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CHAT.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CHEVAL.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CHIEN.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-COCHON.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-DINO-ROSE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-DINO-VERT.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-FLAMINGO.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-FORET.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-HERISSON.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-HIBOU-2026.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-HIBOU.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-INSECTES.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-KOALA.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LAPIN-BLEU.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LAPIN-DOUX.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LICORNE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MINOU.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MONSTRES.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-PANDA.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-PARESSEUX.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-PETITE-FORET.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-PITOU.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-POISSON.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-PUG.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-RENARD-BLEU.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-RENARD-ROSE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-RENARD.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SAVANE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SINGES.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SIRENE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SOUSLOCEAN.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-TORTUES.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          }
        ]
      },
      {
        "id": "sports",
        "name": "SPORTS",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/ensemble-garderie/sports/",
        "models": [
          {
            "file": "GARDERIE-BALLERINE-A.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-BALLERINE-B.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-BASEBALL.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-DOUCE-MELODIE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-HOCKEY-2.0.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-HOCKEY.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MOTOCROSS.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-MULTISPORT.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SKATEBOARD.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SOCCER.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-SURF.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-VOITURE-JAUNE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-VOITURE-ROSE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          }
        ]
      },
      {
        "id": "uni",
        "name": "UNI",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/ensemble-garderie/uni/",
        "models": [
          {
            "file": "GARDERIE-BLANC.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-CIELDETE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-FEUILLU.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LAGRAPPE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LAVAGUE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LECAMOUFLE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LECLATANT.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LEROSEE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LETOILE.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LOCREjpg.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "GARDERIE-LORANGER.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          }
        ]
      }
    ]
  },
  "ensemble-lecolier": {
    "id": "ensemble-lecolier",
    "name": "Ensemble l'écolier",
    "mask": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/_masks/lecolier/lecolier_mask.png",
    "boxes": [
      {
        "type": "free",
        "x": 32,
        "y": 37,
        "scale": 1,
        "textAlign": "left",
        "boxWidth": 300,
        "boxHeight": 152,
        "leftMargin": 14,
        "rightMargin": 14,
        "topMargin": 12,
        "bottomMargin": 401
      }
    ],
    "categories": [
      {
        "id": "aliments",
        "name": "Aliments",
        "baseUrl": "https://pub-b68aae1f520b486ca135c88f677d1634.r2.dev/catalog/ensemble-lecolier/aliments/",
        "models": [
          {
            "file": "lecolier-agrumes-2025.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-agrumes.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-beigne.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-biscuits.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-bleu.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-champignon.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-champignonne.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-cupcake.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-fraise.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-glace.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-mauve.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-melon-deau.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          },
          {
            "file": "lecolier-sushis.jpg",
            "colors": [
              "#000000",
              "#FF1493",
              "#1E90FF",
              "#FFD700"
            ]
          }
        ]
      }
    ]
  }
};
